export const phoneRegExp = /^(\+1|1|)(-| )?\d{3}(-| )?\d{3}(-| )?\d{4}$/;

export const hexColorRegExp = /^#[0-9A-F]{6}$/i;

export const typeRegExp = /^Type\d*/;

export const themeRegExp = /theme\d*/;

export {};
